import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Inline validation message under a sign-up / password field. Pair it with
 * `invalidFieldProps()` on the field (aria-invalid + aria-describedby).
 * Validation used to surface only as a bottom toast, which the iOS/iPadOS
 * on-screen keyboard covers completely, so a rejected sign-up looked like a
 * dead button.
 */
export function FieldError({ id, message }) {
    if (!message)
        return null;
    return (_jsx("p", { id: id, className: "text-xs leading-snug text-red-400", "data-testid": id, children: message }));
}
